// extracted by mini-css-extract-plugin
export var form = "contactForm-module--form--ZO0If";
export var input = "contactForm-module--input--12lrs";
export var message = "contactForm-module--message--1NQ_G";
export var button = "contactForm-module--button--25hnc";
export var info = "contactForm-module--info--z2abS";
export var infoError = "contactForm-module--infoError--2CCWp";
export var honeypot = "contactForm-module--honeypot--3o7zS";
export var srOnly = "contactForm-module--srOnly--1FJNn";